import * as timeUtils from '../../util/time_utils'
import { noTagColor } from '../../util/tag_utils'
import { prepSigilMeta } from './team_sigil'

export function calculateBigTag(foundTag, duration, profile, teams) {

    const canAddTime = !!foundTag && !!profile && canAddTimeEvaluator(foundTag, profile)
    const canEdit    = !!foundTag && !!profile && canEditEvaluator(foundTag, profile)
    const teamSigil = teams && foundTag ? prepSigilMeta(teams[foundTag.teamId]) : undefined

    return {
        "teamSigil": teamSigil,
        "id": foundTag ? foundTag.id : "", // handle "no tag"
        "name": foundTag ? foundTag.name : "No Tag",
        "color": foundTag ? foundTag.color : noTagColor,
        "goal": null, // TODO
        "hours": duration ? timeUtils.make2Places(duration / 60 / 60) : undefined,
        "interval": "this month", // TODO: changeable intervals
        "canEdit": canEdit,
        "canAddTime": canAddTime,
    }
}

function canAddTimeEvaluator(tag, profile) {
    // if the tag isn't recognized or hydrated yet then you can't add time
    if (!tag) {
        return false
    }

    // if its your personal tag you can add time
    if (tag.teamId === profile.personalTeamId) {
        return true
    }

    // can't add time if not a team member of user's team
    const teamMember = profile.memberships[tag.teamId]
    if (!teamMember) {
        return false
    }

    // if you pass all the above tests -- you can add time!
    return true
}

function canEditEvaluator(tag, profile) {
    if (!tag) {
        return false
    }

    // if its your personal tag you can add time
    if (tag.teamId === profile.personalTeamId) {
        return true
    }

    // can't add time if not a team member of user's team
    const teamMember = profile.memberships[tag.teamId]
    if (!teamMember) {
        return false
    }

    // you need to be a member of the team
    if (teamMember.accessLevel !== 'Admin') {
        return false
    }

    // you can edit
    return true
}


// WEBPACK FOOTER //
// ./src/common/components/big_tag.js